import React, { useEffect, useState } from "react";

// reactstrap components
import { Card, CardBody, Table, Row, Col,  Button } from "reactstrap";
import { MDBInput } from "mdb-react-ui-kit";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import axios from "axios";
import {
  RCS_CAMPAIGN_LIST,
  WHATSAPP_CAMPAIGN_DELETE,
  CHANNEL_CLIENT_CHNLTYPE,
} from "../../constants";
import ResponsivePagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
import LoadingScreen from "react-loading-screen";
import logo from "../../assets/img/logo.png";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Select from "react-select";

let templates = [];
let senderids = [];
var initialvalues = {
  fromdate: "",
  todate: "",
  templateid: "",
  senderid: "",
};
const localJson = localStorage.getItem("user");
const user = JSON.parse(localJson);
const Campaignlist = () => {
  const [campaignList, setCampaignList] = useState([]);
  const [campaignListC, setCampaignListC] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = React.useState(false);
  const [alert, setAlert] = React.useState(null);
  const [search, setSearch] = useState(initialvalues);
  const [errorhandle, setErrorHandle] = useState();
  const [channel, setChannel] = useState([]);
  const notificationAlertRef = React.useRef(null);
  useEffect(() => {
    fetchChanelsbyClient();
    getCampaginList(currentPage);
  }, []);

  const getCampaginList = async (page) => {
    setIsLoading(true);
    setCurrentPage(page);
   
    await axios
      .get(
        RCS_CAMPAIGN_LIST +
        "?senderid=" +
        search?.senderid?.value +
        "&page=" +
        page
      )
      .then((res) => {
        setCampaignList(res?.data);
        setCampaignListC(res?.data);
        setIsLoading(false);
      })
      .catch((error) => console.log("error", error));
  };

  const fetchChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "rcs",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          templates = [];

          setChannel(res?.data);

          res?.data?.map((item, i) => {
            item?.template &&
              templates.push({ value: item?.template, label: item?.template });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          setIsLoading(false);
          let options = {};
          options = {
            place: "tr",
            message: "Templates Not Found",
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }));
  };

  const changeSender = (data) => {
    senderids = [];
    const chnl = channel?.filter((item) => item.template == data.value);

    const senderid = chnl[0]?.senderid?.split(",");
    for (let i = 0; i < senderid?.length; i++) {
      senderids.push({ label: senderid[i], value: senderid[i] });
    }

    setSearch((prev) => ({ ...prev, templateid: data, senderid: "" }));
  };

  const filteruser = (val) => {
    const filterobj = campaignListC?.message?.filter(
      (item) =>
        item.campaign.toLowerCase().includes(val.toLowerCase()) ||
        item.sdate.toLowerCase().includes(val.toLowerCase())
    );
    setCampaignList({
      message: filterobj,
    });
  };

  const confirmdelete = (name) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => deleteCampaign(name)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        showCancel
        btnSize=""
      >
        You want to delete campaign ?
      </ReactBSAlert>
    );
  };

  const deleteCampaign = async (name) => {
    await axios
      .post(WHATSAPP_CAMPAIGN_DELETE, { campaign: name })
      .then((res) => {
        getCampaginList(currentPage);
        setAlert(null);
      })
      .catch((err) => console.log("--err-", err));
  };
  return (
    <>
      <div className="content pb-0">
        <Row>
          <Col md="12">
            <Card className="mb-2">
              <CardBody>
                {alert}
                <Row>
                  <Col md="4" sm="12">
                    <p className="category">
                      Select Template<suf style={{ color: "red" }}>*</suf>{" "}
                    </p>
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select"
                      name="templateSelect"
                      value={search.templateid}
                      onChange={(value) => changeSender(value)}
                      options={templates}
                      placeholder="Select"
                    />
                    {errorhandle?.templateid && (
                      <span style={{ color: "red" }}>
                        {errorhandle?.templateid}
                      </span>
                    )}
                  </Col>
                  <Col md="4" sm="12">
                    <p className="category">
                      Select Sender<suf style={{ color: "red" }}>*</suf>{" "}
                    </p>
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select"
                      name="senderSelect"
                      value={search?.senderid}
                      onChange={(value) =>
                        setSearch((prev) => ({ ...prev, senderid: value }))
                      }
                      options={senderids}
                      placeholder="Select"
                    />
                    {errorhandle?.sender && (
                      <span style={{ color: "red" }}>
                        {errorhandle?.sender}
                      </span>
                    )}
                  </Col>
                  <Col md="2" sm="12">
                    <Button
                      className="btn-icon btn btn-primary mt-4"
                      onClick={() => getCampaginList(currentPage)}
                    >
                      <i class="tim-icons icon-double-right"></i>
                    </Button>
                  </Col>
                  <Col md="10"></Col>
                  <Col md="2" sm="12" style={{ float: "right" }}>
                    <MDBInput
                      label="Search"
                      type="text"
                      onChange={(e) => filteruser(e.target.value)}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className="mb-0" md="12">
            <Card className="mb-2">
              <CardBody>
                <LoadingScreen
                  children=""
                  loading={isLoading}
                  bgColor="rgba(0,0,0,0.7)"
                  spinnerColor="#9ee5f8"
                  textColor="#676767"
                  logoSrc={logo}
                  text="Loading..."
                ></LoadingScreen>
                <TableContainer component={Paper} className="tableheight">
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label="simple table"
                    responsive
                    striped
                  >
                    <thead>
                      <tr>
                        <th>S no </th>
                        <th> Campaign Name</th>
                        {/* <th> Status</th>
                        <th> Start Date Time</th>
                        <th> Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {campaignList?.message?.length > 0 ? (
                        campaignList?.message?.map((row, index) => (
                          <tr
                            key={index + 1}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <td component="th" scope="row">
                              {index + 1}
                            </td>
                            <td>{row.campaign_name}</td>
                            {/* <td>{row.status}</td>
                            <td>
                              {row.sdate} {row.stime}
                            </td>
                            <td>
                              {" "}
                              <a
                                to=""
                                value={row}
                                onClick={() => confirmdelete(row.campaign)}
                                className="text-warning ml-2"
                              >
                                <i className="tim-icons icon-trash-simple"></i>
                              </a>
                            </td> */}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5}>No Records Found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </TableContainer>
              </CardBody>
            </Card>
          </Col>
        </Row>
       
        {campaignList?.numOfPages > 0 && (
          <div style={{ width: "30%", float: "right", padding: "8px" }}>
            <ResponsivePagination
              current={currentPage}
              total={campaignList?.numOfPages}
              onPageChange={(newPage) => {
                getCampaginList(newPage);
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Campaignlist;
